import React from 'react';


/* Components ---------------------------*/
import Header from './Header';
import Footer from './Footer';

const Layout = ({children}) => {
    return (
        <>
            <Header />
            <div className="mb-5 main">
                { children }
            </div>
            <Footer />
        </>
    );
}

export default Layout;
